import {
  adminTableData,
  adminTableHead,
  emailAccounts,
  emailAccounts1,
  usersTableHead,
} from "@assets/mocks/tableData";
import Iconify from "@components/iconify";
import { Button } from "@components/ui/button";
import * as Select from "@radix-ui/react-select";
import ReactPaginate from "react-paginate";
import { IconButton, MenuItem, Popover } from "@mui/material";
import { IoAdd } from "react-icons/io5";
import React, { useEffect, useState } from "react";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import Table from "@components/Table";
import { useNavigate } from "react-router";
import SearchInput from "@components/ui/searchInput";
import {
  EmailAccount,
  getAllEmailAccounts,
  deleteEmailAccount,
  getEmailAccountById,
} from "@redux/slices/email";
import useAuth from "@hooks/useAuth";
import { Switch } from "@components/ui/switch";
import { getUsers, UserAccount } from "@redux/slices/auth";
import LoadingScreen from "@components/LoadingScreen";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { Eye, EyeOff } from "lucide-react";

const StrategicPlanning = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [itemOffset, setItemOffset] = useState(0);
  const [accounts, setAccounts] = useState<EmailAccount[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const [users, setUsers] = useState<UserAccount[]>([]);
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showPassId, setShowPassId] = useState<number | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(10); // State for items per page

  const navigate = useNavigate();
  const { user } = useAuth();
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );

  const getData = async () => {
    const accountsData =
      user?.role !== "admin"
        ? await getEmailAccountById(user?.id)
        : selectedUserId !== null
        ? await getEmailAccountById(selectedUserId)
        : user?.role !== "admin"
        ? await getEmailAccountById(user?.id)
        : await getAllEmailAccounts();
    setAccounts(accountsData || []);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const getUsersData = async () => {
    const usersData = await getUsers();
    setUsers(usersData?.filter((i) => i.role !== "admin") || []);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setItemOffset(0);
  };

  const handleDeleteAccount = async (accountId: number) => {
    setLoading(true);
    await deleteEmailAccount(accountId);
    getData();
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getData();
    getUsersData();
  }, []);

  const filteredAccounts = isSearchEnabled
    ? users.filter((user) =>
        user.email.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : accounts.filter((account) =>
        account.email.toLowerCase().includes(searchQuery.toLowerCase())
      );

  const endOffset = itemOffset + itemsPerPage; // Use itemsPerPage state here
  const currentItems = filteredAccounts.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredAccounts.length / itemsPerPage);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % filteredAccounts.length;
    setItemOffset(newOffset);
  };

  const handleItemsPerPageChange = (value: number) => {
    setItemsPerPage(value);
    setItemOffset(0); // Reset to first page when items per page changes
  };

  const handleOpenMenu = (event: any) => {
    setOpenMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="md:flex justify-end items-center mt-7">
            <div className="sm:flex items-center">
              <div className="me-2">
                <div className="relative">
                  <input
                    className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                  <div className="absolute left-0 inset-y-0 flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#71717A"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              {user?.role !== "admin" && (
                <Button
                  className="sm:mt-0 mt-4 bg-[#1CB5AF]"
                  onClick={() => navigate("/emailAccounts/addEmailAccount")}
                >
                  <IoAdd size={20} className="me-2" />
                  Add New Email
                </Button>
              )}
            </div>
          </div>

          <Table
            textIndex={4}
            tableHead={user?.role !== "admin" ? emailAccounts : emailAccounts1}
          >
            {currentItems.map((val, index) => (
              <tr
                key={val.id}
                className="text-sm text-gray text-center border-b last:border-0 border-[#EAECF0]"
              >
                <td className="p-5 w-16">{itemOffset + index + 1}</td>
                <td className="p-5 text-left">{val.email}</td>
                {/* {user?.role !== "admin" && ( */}
                  <td className="p-5 text-left flex justify-center items-center">
                    {showPassId === val.id
                      ? val?.password
                      : val?.password && "•".repeat(val?.password.length)}

                    {showPassId == val.id ? (
                      <Eye
                        onClick={() => setShowPassId(null)}
                        size={16}
                        className="cursor-pointer ms-5"
                      />
                    ) : (
                      <EyeOff
                        onClick={() => setShowPassId(val?.id || null)}
                        size={16}
                        className="cursor-pointer ms-5"
                      />
                    )}
                  </td>
                {/* )} */}
                <td className="p-5 text-left">{val.profile_type}</td>
                <td className="p-5 text-left">{val.server}</td>

                {user?.role !== "admin" && (
                  <td>
                    <IconButton
                      onClick={() =>
                        navigate(`/emailAccounts/editEmailAccount/${val?.id}`)
                      }
                    >
                      <Iconify
                        icon="eva:edit-fill"
                        className="text-lime-700"
                        sx={{ mr: 2 }}
                      />
                    </IconButton>
                    <IconButton
                      className="cursor-pointer"
                      onClick={() => handleDeleteAccount(val.id || 0)}
                    >
                      <Iconify
                        icon="eva:trash-2-outline"
                        className="text-red-600"
                        sx={{ mr: 2 }}
                      />
                    </IconButton>
                  </td>
                  //  <td>
                  //   <IconButton
                  //     onClick={handleOpenMenu}
                  //     sx={{ color: "#98A2B3" }}
                  //   >
                  //     <Iconify icon="eva:more-vertical-fill" />
                  //   </IconButton>
                  //   <Popover
                  //     open={!!openMenu}
                  //     anchorEl={openMenu}
                  //     onClose={handleCloseMenu}
                  //     anchorOrigin={{ vertical: "top", horizontal: "left" }}
                  //     transformOrigin={{
                  //       vertical: "top",
                  //       horizontal: "right",
                  //     }}
                  //     PaperProps={{
                  //       sx: {
                  //         width: 140,
                  //         boxShadow: "rgba(0, 0, 0, 0.02) 0px 3px 8px",
                  //       },
                  //     }}
                  //   >
                  //     <MenuItem>
                  //       <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
                  //       Edit
                  //     </MenuItem>

                  //     <MenuItem sx={{ color: "error.main" }} onClick={() => handleDeleteAccount(val.id)}>
                  //       <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
                  //       Delete
                  //     </MenuItem>
                  //   </Popover>
                  // </td>
                )}
              </tr>
            ))}
          </Table>

          <div className="flex flex-col md:flex-row justify-between items-center mt-8 pb-32">
            <div className="me-2 w-32 md:mb-0 mb-4">
              <Select.Root
                onValueChange={(value) =>
                  handleItemsPerPageChange(Number(value))
                }
              >
                <SelectTrigger className="SelectTrigger bg-white border-none">
                  <SelectValue placeholder={`${itemsPerPage} per Page`} />
                </SelectTrigger>
                <SelectContent className="SelectContent">
                  <SelectItem value="10">10 per page</SelectItem>
                  <SelectItem value="15">15 per page</SelectItem>
                  <SelectItem value="20">20 per page</SelectItem>
                </SelectContent>
              </Select.Root>
            </div>
            <div className="pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel={window.innerWidth > 576 ? "Next  →" : ">"}
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel={window.innerWidth > 576 ? "←  Prev" : "<"}
                renderOnZeroPageCount={null}
                activeClassName="bg-white"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StrategicPlanning;
